import { ReactNode, forwardRef, useImperativeHandle, useRef } from 'react'

import { TPlan, TSelectPlan } from '@/config/types'

import { PrimaryButton } from '@/components/buttons'
import { SelectPlan, SelectPlanV2 } from '@/components/plans/selectPlan'

import { TSelectPlanBlockControl } from './types'

export type TSelectPlanBlockProps = {
  pageConfig: TSelectPlan
  plans: TPlan[]
  selectedPlan: TPlan
  selectPlan: (plan: TPlan) => void
  scrollToAnchor: () => void
  onSelect: () => void
  className?: string
  buttonName?: string
  submitButtonClassName?: string
  additionalBlock?: () => ReactNode
  specificPlanDetailsTitle?: string
  containerWrapperClassName?: string
}

export const SelectPlanBlock = forwardRef<TSelectPlanBlockControl, TSelectPlanBlockProps>(
  function SelectPlanBlock(
    {
      pageConfig,
      plans,
      selectedPlan,
      selectPlan,
      scrollToAnchor,
      onSelect,
      submitButtonClassName,
      additionalBlock,
      specificPlanDetailsTitle,
      containerWrapperClassName,
    }: TSelectPlanBlockProps,
    ref
  ) {
    const {
      planDetailsTitle,
      buttonName,
      afterSelectPlanBlocks,
      afterButtonBlocks,
      smartphoneInfo,
      isShowInput,
      concatPrice,
      showSelectPlanBlockV2 = false,
    } = pageConfig

    const inputRef = useRef<HTMLDivElement>(null)

    useImperativeHandle(
      ref,
      () => {
        return {
          scrollIntoView() {
            inputRef.current?.scrollIntoView()
          },
        }
      },
      []
    )

    const PlanComponent = showSelectPlanBlockV2 ? SelectPlanV2 : SelectPlan

    let containerClassName = 'select-plan-block-wrapper '
    if (containerWrapperClassName) {
      containerClassName += containerWrapperClassName
    }

    return (
      <div className={containerClassName}>
        <div className={showSelectPlanBlockV2 ? 'select-plan-block-v2' : 'select-plan-block'}>
          <PlanComponent
            ref={inputRef}
            planTitle={specificPlanDetailsTitle || planDetailsTitle}
            planDetails={plans}
            selectPlan={selectPlan}
            selectedPlan={selectedPlan}
            isShadow
            additionalBlock={additionalBlock && additionalBlock()}
            isShowInput={isShowInput}
            concatPrice={concatPrice}
          />
          {/* TODO: Rename afterSelectPlanBlocks to beforeButtonBlocks */}
          {afterSelectPlanBlocks &&
            afterSelectPlanBlocks.map((component) => {
              return component(selectedPlan, scrollToAnchor)
            })}
          <div className="button-container prime">
            <PrimaryButton onClick={onSelect} className={submitButtonClassName}>
              <span>{buttonName}</span>
            </PrimaryButton>
            <div className="smartphone-info">{smartphoneInfo}</div>
          </div>
          {afterButtonBlocks &&
            afterButtonBlocks.map((component) => {
              return component(selectedPlan, scrollToAnchor)
            })}
        </div>
      </div>
    )
  }
)
